import { FunctionComponent, useState } from 'react'
import { Group } from '@/types/Group'
import styles from './group.module.scss'
import { TableCell, TableRow } from '@mui/material'
import { Delete } from '@mui/icons-material'
import EditIcon from '@mui/icons-material/Edit'
import ValidDeleteGroupDialog from './Dialog/validDeleteGroupDialog'
import { Daycare } from '@/types/Daycare'
import GroupDialog from './Dialog/groupDialog'

interface GroupRowProps {
    group: Group
    daycare: Daycare
    canUpdate: boolean
    removeOneGroup: (groupId: number) => void
    updateOneGroup: (group: Group) => void
}

const GroupRow: FunctionComponent<GroupRowProps> = ({
    group,
    daycare,
    canUpdate,
    removeOneGroup,
    updateOneGroup
}: GroupRowProps) => {
    const [groupName, setGroupName] = useState<string>(group.name)

    const [isDeleteGroupDialogOpen, setDeleteGroupDialogOpen] = useState<boolean>(false)
    const [isUpdateGroupDialogOpen, setUpdateGroupDialogOpen] = useState<boolean>(false)

    return (
        <>
            <TableRow>
                <TableCell>
                    <div className={styles.GroupNameContainer}>{groupName}</div>
                </TableCell>
                {canUpdate && (
                    <>
                        <TableCell>
                            <EditIcon className={styles.Icon} onClick={() => setUpdateGroupDialogOpen(true)} />
                        </TableCell>
                        <TableCell>
                            <Delete className={styles.Icon} onClick={() => setDeleteGroupDialogOpen(true)} />
                        </TableCell>
                    </>
                )}
            </TableRow>
            <GroupDialog
                open={isUpdateGroupDialogOpen}
                handleClose={() => setUpdateGroupDialogOpen(false)}
                create={false}
                daycare={daycare}
                groupName={groupName}
                setGroupName={setGroupName}
                groupId={group.id}
                updateOneGroup={updateOneGroup}
            />
            <ValidDeleteGroupDialog
                open={isDeleteGroupDialogOpen}
                handleClose={() => setDeleteGroupDialogOpen(false)}
                groupId={group.id}
                daycareId={daycare.id}
                removeOneGroup={removeOneGroup}
            />
        </>
    )
}

export default GroupRow
